export var filterSchema = function filterSchema(schema, groups, orderBy) {
  var obj = {};
  groups.forEach(function (group) {
    obj[group] = schema[group];
  });

  if (orderBy) {
    orderBy.map(function (item) {
      if (obj[item.propertyName]) {
        delete obj[item.propertyName];
      }
    });
  }

  return obj;
};